import { z } from 'zod';
import type { BaseEntity } from './common';
import type { Task } from './task';
import { IntegrationSystemEnum } from './integrationSystem';

/**
 * TaskIntegration - Integrazione task
 * Rappresenta un'integrazione di un task con sistemi esterni
 * Corrisponde al modello backend TaskIntegration
 */
export interface TaskIntegration extends BaseEntity {
	/** ID del task sorgente */
	sourceId: number;
	/** Sistema di integrazione */
	system: IntegrationSystemEnum;
	/** Valore dell'integrazione nel sistema esterno (max 50 caratteri) */
	value: string;
	/** Task sorgente (navigation property, popolata con $expand=source) */
	source?: Task;
}

/**
 * Schema Zod per la validazione runtime dei TaskIntegration
 */
export const TaskIntegrationSchema = z.object({
	id: z.number(),
	sourceId: z.number(),
	system: z.nativeEnum(IntegrationSystemEnum),
	value: z.string(),
	// Campi audit da BaseEntity
	createdAt: z.string(),
	modifiedAt: z.string().optional(),
	createdBy: z.string(),
	modifiedBy: z.string().optional(),
	// Navigation property opzionale (non validata in runtime)
	source: z.any().optional(),
});
